import NotificationMixin from '@/app/arch/mixins/NotificationMixin';

export default {
  mixins: [NotificationMixin],
  data: () => ({
    display: false,
    selecteds: false,
    rows: [],
    labels: {
      selectOne: 'Remover selecionado',
      selectMultiple: 'Remover selecionados',
      dialogOne: 'este item selecionado',
      dialogMultiple: 'todos os items selecionados',
      dialogPreText: 'Essa ação irá remover permanentemente',
    },
  }),
  computed: {
    showButton() {
      return this.display;
    },
    getLabel() {
      return this.selecteds ? this.labels.selectMultiple : this.labels.selectOne;
    },
    setDeleteDialog() {
      return {
        title: `Deseja ${this.getLabel.toLowerCase()}?`,
        text: `${this.labels.dialogPreText} ${
          this.selecteds
            ? this.labels.dialogMultiple
            : this.labels.dialogOne
        }`,
      };
    },
  },
  created() {
    this.onEvents();
  },
  methods: {
    handleDisplay() {
      this.$root.$on('selected-all', (value) => {
        this.display = value;
        this.selecteds = value;
      });
    },
    handleSelected() {
      this.$root.$on('selected-all-rows', (rows) => {
        const selects = rows.filter(({ value }) => value === true);
        this.rows = selects.map(({ row }) => row);

        if (selects.length === 1) {
          this.display = true;
          this.selecteds = false;
        } else if (selects.length > 1) {
          this.display = true;
          this.selecteds = true;
        } else {
          this.display = false;
        }
      });
    },
    onEvents() {
      this.handleDisplay();
      this.handleSelected();
    },
    makeDelete() {
      this.showConfirmDeleteDialog(this.setDeleteDialog)
        .then((data) => {
          if (data.value) {
            this.confirmedActions();
          }
        });
    },
    confirmedActions() {
      this.$root.$emit('remove-select-rows', this.rows);
    },
  },
};
